var _style, _g, _g2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 223.7 43",
    style: {
      enableBackground: "new 0 0 223.7 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1C19F1;}\n\t.st1{fill:#02B3FD;}\n\t.st2{fill:url(#SVGID_1_);}\n\t.st3{fill:url(#multim_1_);}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.5,2.7L46.1,35c1.5,2.6-0.4,5.9-3.4,5.9H5.4c-3,0-4.9-3.3-3.4-5.9L20.7,2.7C22.2,0.1,26,0.1,27.5,2.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.3,2.7L67,35c1.5,2.6-0.4,5.9-3.4,5.9H26.3c-3,0-4.9-3.3-3.4-5.9L41.5,2.7C43,0.1,46.8,0.1,48.3,2.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.8198,
    y1: -53.05,
    x2: 46.1803,
    y2: -53.05,
    gradientTransform: "matrix(1 0 0 -1 0 -25)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#02B3FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1C19F1"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.6,34.2L34.5,15L23.4,34.2c-1.8,3.1,0.4,6.9,4,6.9h14.2C45.1,41,47.3,37.2,45.6,34.2z"
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "multim_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.8,
    y1: 16.0437,
    x2: 262.0081,
    y2: 16.0437,
    gradientTransform: "matrix(1 0 0 -1 0 43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C19F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#02B3FD"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "multim",
    className: "st3",
    d: "M104.9,14.3l-6.7,17.6l-6.9-17.6h-7.5v25.3H90V23.7l5.5,15.8h5.3l5.5-15.8v15.8h6.2V14.3H104.9z  M116.5,14.1v14.7c-0.1,2.1,0.4,4.2,1.3,6.1c0.8,1.6,2.1,2.9,3.7,3.7c1.7,0.8,3.5,1.3,5.4,1.2c1.9,0,3.8-0.4,5.5-1.2 c1.6-0.8,3-2.1,3.8-3.7c1-1.9,1.5-4,1.4-6.1V14.1h-6.2v14.7c0.1,1.4-0.3,2.7-1.1,3.9c-1.8,1.8-4.8,1.8-6.6,0 c-0.8-1.1-1.2-2.5-1.1-3.9V14.1C122.6,14.1,116.5,14.1,116.5,14.1z M147.8,14.1h-6.2v25.5H156v-4.7h-8.2 C147.8,34.9,147.8,14.1,147.8,14.1z M157.2,14.1V19h6.8v20.6h6.2V19h6.9v-4.9H157.2L157.2,14.1z M179.7,14.1v25.5h6.2V14.1H179.7z  M211.2,14.3l-6.7,17.6l-6.9-17.6h-7.5v25.3h6.2V23.7l5.5,15.8h5.3l5.5-15.8v15.8h6.2V14.3H211.2L211.2,14.3z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.74e778e3ca17bd9b499d679edc6efa55.svg";
export { ForwardRef as ReactComponent };